// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-container .emd-container__footer .emd-btn[data-v-2cca80a4] {\n  margin-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
